export const ORGANIZATION_TITLES = [
    { value: '', label: 'Organization Title*' },
    { label: 'Administrator', value: 'Administrator' },
    { label: 'Analyst', value: 'Analyst' },
    { label: 'Assistant Professor', value: 'Assistant Professor' },
    { label: 'Associate Professor', value: 'Associate Professor' },
    { label: 'Biostatistician', value: 'Biostatistician' },
    { label: 'Brand Manager', value: 'Brand Manager' },
    { label: 'Business Analyst', value: 'Business Analyst' },
    { label: 'Business Development Manager', value: 'Business Development Manager' },
    { label: 'Clinical Research Associate', value: 'Clinical Research Associate' },
    { label: 'Clinical Research Coordinator', value: 'Clinical Research Coordinator' },
    { label: 'Compliance Officer', value: 'Compliance Officer' },
    { label: 'Coordinator', value: 'Coordinator' },
    { label: 'Customer Success Manager', value: 'Customer Success Manager' },
    { label: 'Data Curator', value: 'Data Curator' },
    { label: 'Data Entry Operator', value: 'Data Entry Operator' },
    { label: 'Data Engineer', value: 'Data Engineer' },
    { label: 'Data Manager', value: 'Data Manager' },
    { label: 'Data Scientist', value: 'Data Scientist' },
    { label: 'Database Administrator', value: 'Database Administrator' },
    { label: 'Department Head', value: 'Department Head' },
    { label: 'Developer', value: 'Developer' },
    { label: 'Director of Operations', value: 'Director of Operations' },
    { label: 'Discovery Scientist', value: 'Discovery Scientist' },
    { label: 'Doctor', value: 'Doctor' },
    { label: 'Ethics Coordinator', value: 'Ethics Coordinator' },
    { label: 'Formulation Scientist', value: 'Formulation Scientist' },
    { label: 'Global Coordinator', value: 'Global Coordinator' },
    { label: 'Grants Manager', value: 'Grants Manager' },
    { label: 'Implementation Consultant', value: 'Implementation Consultant' },
    { label: 'Integration Engineer', value: 'Integration Engineer' },
    { label: 'Investigator', value: 'Investigator' },
    { label: 'Key Account Manager', value: 'Key Account Manager' },
    { label: 'Lab Technician', value: 'Lab Technician' },
    { label: 'Learning and Development Specialist', value: 'Learning and Development Specialist' },
    { label: 'Legal Counsel', value: 'Legal Counsel' },
    { label: 'Medical Science Liaison', value: 'Medical Science Liaison' },
    { label: 'Medical Writer', value: 'Medical Writer' },
    { label: 'Officer (Regulatory, Compliance, QA, etc.)', value: 'Officer (Regulatory, Compliance, QA, etc.)' },
    { label: 'PhD Scholar', value: 'PhD Scholar' },
    { label: 'Pharmacovigilance Associate', value: 'Pharmacovigilance Associate' },
    { label: 'Postdoctoral Fellow', value: 'Postdoctoral Fellow' },
    { label: 'Product Lifecycle Manager', value: 'Product Lifecycle Manager' },
    { label: 'Product Manager', value: 'Product Manager' },
    { label: 'Professor', value: 'Professor' },
    { label: 'Program Manager', value: 'Program Manager' },
    { label: 'Project Fellow', value: 'Project Fellow' },
    { label: 'Project Manager', value: 'Project Manager' },
    { label: 'Quality Monitor', value: 'Quality Monitor' },
    { label: 'QA Officer', value: 'QA Officer' },
    { label: 'Research Associate', value: 'Research Associate' },
    { label: 'Research Fellow', value: 'Research Fellow' },
    { label: 'Research Scientist', value: 'Research Scientist' },
    { label: 'Resident', value: 'Resident' },
    { label: 'Sample Coordinator', value: 'Sample Coordinator' },
    { label: 'Safety Scientist', value: 'Safety Scientist' },
    { label: 'Software Engineer', value: 'Software Engineer' },
    { label: 'Solutions Architect', value: 'Solutions Architect' },
    { label: 'Strategy Analyst', value: 'Strategy Analyst' },
    { label: 'Strategy Lead', value: 'Strategy Lead' },
    { label: 'Study Monitor', value: 'Study Monitor' },
    { label: 'System Analyst', value: 'System Analyst' },
    { label: 'Technical Support Specialist', value: 'Technical Support Specialist' },
    { label: 'Technical Writer', value: 'Technical Writer' },
    { label: 'Toxicologist', value: 'Toxicologist' },
    { label: 'Translational Researcher', value: 'Translational Researcher' },
    { label: 'Trial Manager', value: 'Trial Manager' },
    { label: 'Validation Specialist', value: 'Validation Specialist' },
    { label: 'Vice President (VP)', value: 'Vice President (VP)' },
    { label: 'Program Director', value: 'Program Director' }
];

export const SIGN_UP = {
    TITLES: {
        HEADER: 'Sign Up for New Account',
        USER_DETAILS: 'User Details',
        ORG_DETAILS: 'Organization Details',
        ALMOST_THERE: 'Almost There!',
        ACCOUNT_CREATED: "Your account has been created successfully.",
        STEP_TEXT: (current, total) => `Step ${current} of ${total}`,
    },
    PLACEHOLDERS: {
        FIRST_NAME: 'First Name*',
        LAST_NAME: 'Last Name*',
        EMAIL: 'Org. Email Address*',
        CONTACT: 'Contact Number',
        DOCTOR_ID: 'Doctor ID (4basecare)*',
        ORG_NAME: 'Organization Name*',
        ORG_TITLE: 'Organization Title*',
        COUNTRY: 'Country*',
        REASON: 'Reason for Signing Up',
    },
    BUTTONS: {
        NEXT: 'Next',
        SIGN_UP: 'Sign Up',
        LOG_IN: 'Log In',
    },
    TERMS: {
        AGREE_TEXT: 'I agree to the',
        TERMS_OF_SERVICE: 'Terms of Service',
        PRIVACY_POLICY: 'Privacy Policy'
    },
    ERRORS: {
        FIRST_NAME_REQUIRED: 'First Name is required',
        LAST_NAME_REQUIRED: 'Last Name is required',
        EMAIL_REQUIRED: 'Organization Email is required',
        EMAIL_INVALID: 'Please enter a valid email address',
        CONTACT_INVALID: 'Contact Number should contain only numbers',
        DOCTOR_ID_REQUIRED: 'Doctor ID is required',
        ORG_NAME_REQUIRED: 'Organization Name is required',
        ORG_TITLE_REQUIRED: 'Organization Title is required',
        COUNTRY_REQUIRED: 'Country is required'
    },
    FOOTER: {
        ALREADY_ACCOUNT: "Already have an account?",
        SIGN_IN_TEXT: 'Log In'
    }
};